'use strict';

exports.__esModule = true;
exports.createRequestCacheGenerator = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _effects = require('redux-saga/effects');

var _ramda = require('ramda');

var _actionHelpers = require('../actionHelpers');

var _asyncHelpers = require('../asyncHelpers');

var _doAction = require('./doAction');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var createRequestCacheGenerator = exports.createRequestCacheGenerator = function createRequestCacheGenerator(_ref) {
  var getItem = _ref.getItem,
      setItem = _ref.setItem;
  return (
    /*#__PURE__*/
    _regenerator2.default.mark(function _callee(actionFn, action) {
      var path, response, lastSucceedAt, item, _response, _lastSucceedAt, attrs;

      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              path = (0, _asyncHelpers.getPath)(action.params || _asyncHelpers.noParamsKey);
              actionFn = (0, _ramda.compose)((0, _ramda.merge)({
                requestAction: action
              }), actionFn);
              _context.prev = 2;
              _context.next = 5;
              return (0, _effects.put)((0, _actionHelpers.asRequest)(actionFn(null)));

            case 5:
              return _context.delegateYield((0, _doAction.doAction)(action), 't0', 6);

            case 6:
              response = _context.t0;
              lastSucceedAt = new Date().toISOString();
              _context.next = 10;
              return (0, _effects.put)((0, _actionHelpers.asSuccess)(actionFn(response, {
                lastSucceedAt: lastSucceedAt
              })));

            case 10:
              setItem(action.type + '/' + path, {
                response: response,
                lastSucceedAt: lastSucceedAt
              });
              return _context.abrupt('return', {
                response: response
              });

            case 14:
              _context.prev = 14;
              _context.t1 = _context['catch'](2);
              _context.prev = 16;
              _context.next = 19;
              return getItem(action.type + '/' + path);

            case 19:
              item = _context.sent;

              if (item) {
                _context.next = 22;
                break;
              }

              throw new Error('Can\'t get item from cache');

            case 22:
              _response = item.response, _lastSucceedAt = item.lastSucceedAt;
              attrs = {
                error: _context.t1,
                lastSucceedAt: _lastSucceedAt
              };
              _context.next = 26;
              return (0, _effects.put)((0, _actionHelpers.asSuccess)(actionFn(_response, attrs)));

            case 26:
              _context.next = 32;
              break;

            case 28:
              _context.prev = 28;
              _context.t2 = _context['catch'](16);
              _context.next = 32;
              return (0, _effects.put)((0, _actionHelpers.asError)(actionFn(_context.t1)));

            case 32:
              return _context.abrupt('return', {
                error: _context.t1
              });

            case 33:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this, [[2, 14], [16, 28]]);
    })
  );
};